import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Table, Spin} from 'antd'
import uniqid from 'uniqid'
import {formatCurrency} from 'Utils'

import style from './style.sass'

@inject('store') @observer
class Debug extends Component {
  componentDidMount() {
    const id = this.props.match.params.backtestID
    this.props.store.backtest.debug.getData(id)
  }
  getRows = (data, index) => {
    let rows = []
    for (let i=0; i<index.length; i++) {
      rows.push(
        <tr key={index[i]}>
          <th>{index[i]}</th>
          {data[i].map((row, index) => <td key={index}>{typeof row === 'object' ? JSON.stringify(row) : row}</td>)}
        </tr>
      )
    }
    return rows
  }
  getObjData = (obj) => {
    let data = []
    for (let name in obj) {
      let position = obj[name]
      let row
      switch (name) {
      case 'indicators':
        row = (
          <tr>
            <td>{name}: </td>
            <td>
              <table>
                {position.map(ind =>
                  (<tr key={uniqid()}>{ind.map(row =>
                    (typeof row === 'object') ?
                      <td key={uniqid()}>{JSON.stringify(row)}: </td>
                      : (typeof row === 'number') ?
                        <td key={uniqid()}>{row.toLocaleString('en-US')}</td>
                        :
                        <td key={uniqid()}>{row}</td>
                  )}</tr>)
                )}
              </table>
            </td>
          </tr>
        )
        break
      case 'signal_parts':
        row = (
          <tr>
            <td>{name}: </td>
            <td>
              {position.map(row =>
                <p key={uniqid()}>{row}</p>
              )}
            </td>
          </tr>
        )
        break
      case 'result':
        row = (
          <tr>
            <td>Condition met? </td>
            <td style={{color: position ? '#81c868' : '#f05050'}}>
              {position ? 'yes' : 'no'}
            </td>
          </tr>
        )
        break
      case 'has_open_positions_for_ticker':
        row = (
          <tr>
            <td>Has open positions? </td>
            <td style={{color: position ? '#81c868' : '#f05050'}}>
              {position ? 'yes' : 'no'}
            </td>
          </tr>
        )
        break
      default:
        if (typeof position === 'object') {
          row = (
            <tr>
              <td>{name}: </td>
              <td>{this.getObjData(position)}</td>
            </tr>
          )
        } else {
          row = (
            <tr>
              <td>{name}: </td>
              <td>{typeof position === 'number' ? formatCurrency(position) : position}</td>
            </tr>
          )
        }
      }
      data.push(row)
    }
    return <table>{data}</table>
  }
  expandRow = (record) => (
    <table style={{width: '100%'}}>
      <tbody>
        <tr>
          <td>Current cash: </td>
          <td>{formatCurrency(record.data.current_cash)}</td>
        </tr>
        <tr>
          <td>Current portfolio value: </td>
          <td>{formatCurrency(record.data.portfolio_value)}</td>
        </tr>
        <tr>
          <td>Positions: </td>
          <td>
            {this.getObjData(record.data.positions)}
          </td>
        </tr>
        <tr>
          <td>Tickers: </td>
          <td>
            {this.getObjData(record.data.tickers)}
          </td>
        </tr>
      </tbody>
    </table>
  )
  render() {
    const store = this.props.store.backtest.debug
    const {columns, data, index} = store.results
    const debugCols = [{
      title: 'Date',
      dataIndex: 'date',
      sorter: (a, b) => new Date(a.date) - new Date(b.date)
    }, {
      title: 'Was any signal condition met?',
      dataIndex: 'condition',
      sorter: (a, b) => a.condition.localeCompare(b.condition)
    }, {
      title: 'Was any cover trade triggered?',
      dataIndex: 'cover',
      sorter: (a, b) => a.cover.localeCompare(b.cover)
    }]
    const debugData = store.debugResults.slice()

    if (store.loading) {
      return(
        <Spin size='large'>
          <div style={{height:'100vh', width:'100vw'}}/>
        </Spin>
      )
    }
    return(
      <div>
        <div className='card' styleName='debug'>
          <p><b>{store.backtest.algo.signal}</b></p>
          <p>{JSON.stringify(store.backtest.algo.config)}</p>
          <p>{JSON.stringify(store.backtest.algo.additional_config)}</p>
          <hr/>
          <div className='row'>
            <div className='col-lg-6'>
              <Table
                columns={debugCols}
                dataSource={debugData}
                expandedRowRender={this.expandRow}
                size='small'
              />
            </div>
            <div className='col-lg-6'>
              <Table
                columns={debugCols}
                dataSource={debugData}
                expandedRowRender={this.expandRow}
                size='small'
              />
            </div>
          </div>
          <hr/>
          <div style={{height:450, overflow:'scroll'}}>
            <table className='dataframe table-bordered table'>
              <thead>
                <tr>
                  <th></th>
                  {columns.map(row => <th key={row}>{row}</th>)}
                </tr>
              </thead>
              <tbody>
                {this.getRows(data, index)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default Debug
